import {isInRange, isInsideArea, swap} from "../editor/utils";

import {
    edgeBrushPath,
    radianFromPoint,
    spanPath,
} from "./circularShape";

const circumferenceRadian = Math.PI * 2;

class Brush {
    constructor() {
        this.originX = 0;
    }

    /**
     * @param {Object} container
     */
    init(container) {
        this.container = container;
        this.brushYPosition = 0;
        this.innerRadius = 0;

        this.brushSize = {
            start: 0,
            end: 0,
            direction: 1
        }
    }

    /**
     *
     */
    create(enableMarker) {
        this.enableMarker = enableMarker;

        this.brush = this.container
            .append("path")
            .attr("class", "brush");

        this.brushFirstEdge = this.container
            .append("path")
            .attr("class", "firstEdge");

        this.brushSecondEdge = this.container
            .append("path")
            .attr("class", "secondEdge");

        return [this.brush, this.brushFirstEdge, this.brushSecondEdge];
    }

    /**
     *
     */
    draw() {
        this.brush
            .attr("d", spanPath(this.circle.radius, this.innerRadius, this.brushSize.start, this.brushSize.end));

        this.brushFirstEdge
            .attr("d", edgeBrushPath(this.circle.radius, this.innerRadius, this.brushSize.start, this.enableMarker))

        this.brushSecondEdge
            .attr("d", edgeBrushPath(this.circle.radius, this.innerRadius, this.brushSize.end, this.enableMarker))
    }


    /**
     *
     * @param {*} dragEvent
     * @param {*} scroll
     */
    onCreateBrush(dragEvent, scroll = 0) {
        if (dragEvent.type === "start") {
            let initRadian = radianFromPoint(dragEvent.x - this.circle.center.x, dragEvent.y - this.circle.center.y)

            this.brushSize = {
                start: initRadian,
                end: initRadian,
                direction: 1
            }
            this.previousRadian = initRadian;

        } else if (dragEvent.type === "drag") {
            let currentRadian = radianFromPoint(dragEvent.x - this.circle.center.x, dragEvent.y - this.circle.center.y);

            this.brushSize.start += scroll;
            this.brushSize.direction = currentRadian > this.brushSize.start ? 1 : -1;
            if (Math.abs(currentRadian - this.previousRadian) > Math.PI) {
                if (this.brushSize.direction === 1) {
                    currentRadian -= circumferenceRadian;
                } else {
                    currentRadian += circumferenceRadian;
                }
            }

            this.brushSize.end = currentRadian;
            this.previousRadian = currentRadian;
        } else {
            if (this.brushSize.start > this.brushSize.end) {
                [this.brushSize.start, this.brushSize.end] = swap(this.brushSize.start, this.brushSize.end)
                this.brushSize.direction = 1
            }

            if (this.brushSize.start < 0 && this.brushSize.end < 0) {
                this.brushSize.start += circumferenceRadian;
                this.brushSize.end += circumferenceRadian;
            }

            if (this.brushSize.start < 0 && this.brushSize.end > 0) {
                this.brushSize.start += circumferenceRadian;
                this.brushSize.end += circumferenceRadian;
            }
        }
        this.draw();
    }

    /**
     * @param {*} dragEvent
     */
    onDrag(dragEvent) {
        if (dragEvent.type === "start") {
            this.currentRadian = radianFromPoint(dragEvent.x, dragEvent.y)
            this.currentX = this.currentRadian;

            this.offsetDragRadian = this.currentRadian - this.brushSize.start;
            this.brushSizeRadian = this.brushSize.end - this.brushSize.start
        } else if (dragEvent.type === "drag") {
            const currentTmpRadian = radianFromPoint(dragEvent.x, dragEvent.y)
            this.brushSize.start = currentTmpRadian - this.offsetDragRadian
            this.brushSize.end = this.brushSize.start + this.brushSizeRadian
        }
        this.draw();
    }

    /**
     *
     * @param {*} dragEvent
     * @param {*} selector
     * @param {*} scroll
     */
    onDragEdges(dragEvent, selector, scroll = 0) {
        if (dragEvent.type === "start") {
            if (this.brushSize.start < 0 && this.brushSize.end < 0) {
                this.brushSize.start += circumferenceRadian;
                this.brushSize.end += circumferenceRadian;
            }

            this.previousBrushSize = {
                ...this.brushSize
            }

            this.previousRadian = selector.attr("class") === "secondEdge" ? this.brushSize.end : this.brushSize.start;
        } else if (dragEvent.type === "drag") {

            let currentRadian = radianFromPoint(dragEvent.x, dragEvent.y);
            currentRadian += currentRadian < 0 ? circumferenceRadian : 0;

            this.brushSize.direction = currentRadian > this.brushSize.start ? 1 : -1;

            if (this.previousBrushSize.start < circumferenceRadian && this.previousBrushSize.end > circumferenceRadian) {
                if (selector.attr("class") === "secondEdge") {
                    this.brushSize.start += scroll;
                    currentRadian += this.previousBrushSize.end > circumferenceRadian ? circumferenceRadian : 0
                    if (Math.abs(currentRadian - this.previousRadian) > Math.PI) {
                        currentRadian -= circumferenceRadian
                    }
                    this.brushSize.end = currentRadian
                } else {
                    this.brushSize.end += scroll;
                    if (Math.abs(currentRadian - this.previousRadian) > Math.PI) {
                        currentRadian += circumferenceRadian
                    }
                    this.brushSize.start = currentRadian
                }
            } else {
                if (selector.attr("class") === "secondEdge") {
                    this.brushSize.start += scroll;
                    if (Math.abs(currentRadian - this.previousRadian) > Math.PI) {
                        if (this.brushSize.direction !== 1) {
                            currentRadian += circumferenceRadian
                        } else {
                            currentRadian -= circumferenceRadian
                        }
                    }

                    this.brushSize.end = currentRadian
                } else {
                    this.brushSize.end += scroll;
                    if (Math.abs(currentRadian - this.previousRadian) > Math.PI) {
                        if (this.brushSize.direction !== -1) {
                            currentRadian -= circumferenceRadian
                        } else {
                            currentRadian += circumferenceRadian
                        }
                    }
                    this.brushSize.start = currentRadian;
                }
            }

            this.previousRadian = currentRadian;
        }
        this.draw();
    }

    getParameters() {
        let start, end, direction;
        start = this.brushSize.start;
        end = this.brushSize.end;
        direction = this.brushSize.direction;

        if (this.brushSize.direction === -1 && start > end) {
            [start, end] = swap(this.brushSize.start, this.brushSize.end);
            direction = 1;
        }

        if (start < 0) {
            start += circumferenceRadian;
            end += circumferenceRadian;
        }

        return {
            start: start,
            end: end,
            direction: direction
        };
    }

    getCurrentX() {
        return this.currentX;
    }

    /**
     *
     * @param {*} newParameters
     */
    setParameters(newParameters) {
        this.brushSize = newParameters;
        this.draw();
    }

    setUp(circle, height, sequenceLength) {
        this.circle = circle;
        this.innerRadius = (height || this.circle.radius);
        this.sequenceLength = sequenceLength;

        this.draw();
    }

    /**
     *
     */
    hide() {
        this.brush.style("opacity", "0")
        this.brushFirstEdge.style("opacity", "0")
        this.brushSecondEdge.style("opacity", "0")
    }

    /**
     *
     */
    show() {
        this.brush.style("opacity", ".2")
        this.brushFirstEdge.style("opacity", "1")
        this.brushSecondEdge.style("opacity", "1")
    }

    get() {
        return this.brush;
    }
}

export default Brush;